var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "var(--color__prim-shade--1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color__prim-tint--2)",
    d: "M27.61 21.117a.56.56 0 0 0-.47.103 5.996 5.996 0 0 1-1.82 1.068c-.635.247-1.33.37-2.067.37a6.004 6.004 0 0 1-4.256-1.767 6.054 6.054 0 0 1-1.76-4.273c0-.699.123-1.377.328-1.993a5.523 5.523 0 0 1 .982-1.767.526.526 0 0 0-.082-.74c-.143-.102-.307-.143-.47-.102a8.255 8.255 0 0 0-4.338 2.917A8.127 8.127 0 0 0 12 19.864c0 2.24.9 4.273 2.373 5.753A8.02 8.02 0 0 0 20.102 28a8.104 8.104 0 0 0 7.877-6.246.499.499 0 0 0-.368-.637Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.0bab84499f72219d57875a4d40b94cdb.svg";
export { ForwardRef as ReactComponent };